/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component } from '@angular/core';
import { PermissionsPermissions } from '@app/core/permissions';
import { ToastService } from '@app/core/services/toast/toast.service';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { Observable, take } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ExternalSystemFieldsLogicService } from '@app/logic/external-system-fields/external-system-fields.logic-service';
import { ExternalSystemFieldMappedItem } from '@app/logic/external-system-fields/external-system-fields.mapped';
import { EXTERNAL_SYSTEM_ENUM, EXTERNAL_SYSTEM_FIELD_TYPE_ENUM, IExternalSystemFieldTemplateItemDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { ExternalSystemFieldDialogComponent } from './external-system-field-dialog/external-system-field-dialog.component';


@Component({
    selector: 'cb-external-system-fields',
    templateUrl: './external-system-fields.component.html',
    styleUrls: ['./external-system-fields.component.scss'],
    standalone: false
})
export class ExternalSystemFieldsComponent extends BaseSimpleListViewDirective<IExternalSystemFieldTemplateItemDto, ExternalSystemFieldsLogicService> {

    public sortOrderChanged = false;

    public readonly displayedColumns: string[] = ['External Field Name', 'Field Type', 'Field Length', 'Active', ''];

    public EXTERNAL_SYSTEM_FIELD_TYPE_ENUM = EXTERNAL_SYSTEM_FIELD_TYPE_ENUM;

    public savingOrder = false;

    constructor(
        public readonly toastService: ToastService,
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly dialog: CbDialogService,
        private readonly externalSystemFieldsLogicService: ExternalSystemFieldsLogicService,
    ) {
        super(
            dialog,
            externalSystemFieldsLogicService,
            ExternalSystemFieldDialogComponent,
            'External System Fields',
            ExternalSystemFieldMappedItem,
            permissionsPermissions,
            true,
            '50%'
        );
    }

    public drop(event: CdkDragDrop<IExternalSystemFieldTemplateItemDto[]>): void {
        if (event.previousIndex === event.currentIndex) return;
        moveItemInArray(this.searchResults, event.previousIndex, event.currentIndex);
        this.sortOrderChanged = true;
    }

    public getSearchResults(): Observable<any> {
        return this.logicService.getListBySystemId(EXTERNAL_SYSTEM_ENUM.CostX);
    }

    protected handleNewItem = (item: any) => {
        super.handleNewItem(item);
    };

    protected handleSearchResults = (searchResults: Array<IExternalSystemFieldTemplateItemDto>) => {
        super.handleSearchResults(searchResults);
    };

    public saveOrder(): void {
        this.dialog
            .confirm({
                message: 'Are you sure you want to save the order of the External System Fields?',
                declined: () => {
                    this.savingOrder = false;
                },
                confirmed: this.handleSaveOrder,
            });
    }

    private readonly handleSaveOrder = (): void => {
        const idsInNewOrder = this.searchResults.map(item => item.id);
        this.externalSystemFieldsLogicService
            .saveOrder(idsInNewOrder, EXTERNAL_SYSTEM_ENUM.CostX)
            .pipe(take(1)).subscribe((result) => {
                this.searchResults = result;
                this.sortOrderChanged = false;
                this.savingOrder = false;
            });
    };

    public deleteItem(item: IExternalSystemFieldTemplateItemDto): void {
        this.deleteItemClicked(item, { heading: 'External System Fields', message: `Are you sure you want to delete ${item.fieldName} External System Fields?` });
    }

}
